import { View, Text } from 'react-native';
import React, { useEffect, useState } from 'react';

interface IShowMessagePass {
  errorsMessage?: string[];
}

const ShowMessagePass = ({ errorsMessage }: IShowMessagePass) => {

    const [sixCaracteres, setSixCaracteres] = useState(false)
    const [oneNumber, setOneNumber] = useState(false)
    const [upperCase, setUpperCase] = useState(false)
    const [lowerCase, setLowerCase] = useState(false)
    const [especial, setEspecial] = useState(false)

  useEffect(() => {
    setSixCaracteres(!!errorsMessage?.find(item => item?.includes('6 caracteres')))
    setOneNumber(!!errorsMessage?.find(item => item?.includes('um numero')))
    setUpperCase(!!errorsMessage?.find(item => item?.includes('letra maiuscula')))
    setLowerCase(!!errorsMessage?.find(item => item?.includes('letra minuscula')))
    setEspecial(!!errorsMessage?.find(item => item?.includes('caractere especial')))
  }, [errorsMessage])

  return (
    <View style={{marginTop: 20}}>
    <Text style={{marginBottom: 10}}>A senha deve conter pelo menos:</Text>
      <Text style={sixCaracteres ? { color: 'red', textDecorationLine: 'line-through' } : { color: 'green' }}>6 caracteres</Text>
      <Text style={oneNumber ? { color: 'red', textDecorationLine: 'line-through' } : { color: 'green' }}>Um número</Text>
      <Text style={upperCase ? { color: 'red', textDecorationLine: 'line-through' } : { color: 'green' }}>Uma letra maiúscula</Text>
      <Text style={lowerCase ? { color: 'red', textDecorationLine: 'line-through' } : { color: 'green' }}>Uma letra minúscula</Text>
      <Text style={especial ? { color: 'red', textDecorationLine: 'line-through' } : { color: 'green' }}>Um caractere especial</Text>
    </View>
  );
};

export default ShowMessagePass;
